import { Injectable } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LoaderComponent } from '@core/components/loader/loader.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private overlayRef = this.overlay.create({
    positionStrategy: this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically(),
    hasBackdrop: true,
  });

  constructor(private overlay: Overlay) {}

  public show(): void {
    if (!this.overlayRef.hasAttached()) {
      this.overlayRef.attach(new ComponentPortal(LoaderComponent));
    }
  }

  public hide(): void {
    this.overlayRef.detach();
  }
}
